import { Pipe, PipeTransform, inject } from "@angular/core";
import { AtgardService } from "../../services/atgard.service";

@Pipe({ name: "avverkningsgruppForkortning" })
export class AvverkningsgruppForkortningPipe implements PipeTransform {
    private readonly atgardService = inject(AtgardService);

    transform(value: unknown, ...args: unknown[]): unknown {
        return this.atgardService.getAvverkningsgruppForkortning(value as any);
    }
}
